import bootbox from 'bootbox';
import tinymce from 'tinymce/tinymce';
import 'tinymce/icons/default';
import {template, update} from "lodash";
import * as JSPM from 'jsprintmanager';

$(document).ready(function (e) {

    let mceEditor = null,
        selectedElement = null;

    $('.print-template').on('click', function (e) {
        e.preventDefault();
        let url = $(this).attr('href');
        let pdfw = window.open(url, '_blank');
        pdfw.focus();
        pdfw.onload = function () {
            pdfw.print();
        }
    });

    $(document).on('click', '.print-template-multi', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass('selected');
        let $printBtn = $(this).parents('.dropdown-menu').find('.print-options');

        if ($(this).hasClass('selected')) {
            $(this).find('.fa-check').removeClass('d-none');
        } else {
            $(this).find('.fa-check').addClass('d-none');
        }

        let selected_items = $(this).parents('.dropdown-menu').find('.print-template-multi.selected').length;
        if (selected_items > 0) {
            $printBtn.removeClass('d-none');
        } else {
            $printBtn.addClass('d-none');
        }
    });

    function printDocuments(urls) {
        toastr.info(`Dispatched ${urls.length} pdfs print jobs`);

        urls.forEach(url => {
            const separator = url.includes('?') ? '&' : '?';
            const modifiedUrl = `${url}${separator}print_template=true`;

            $.ajax({
                type: 'GET',
                url: modifiedUrl,
                success: function(res) {
                },
                error: function() {
                    toastr.error(`Failed to dispatch print job for: ${modifiedUrl}`);
                }
            });
        });
    }

    function updatePrintCounter(records) {
        $.ajax({
            type: 'POST',
            url: '/relation/section/print_count',
            data: {
                records,
            }
        })
    }

    $(document).on('click', '.print-multi-templates', function (e) {
        e.preventDefault();
        e.stopPropagation();
        let $templates = $(this).parents('.dropdown-menu').find('.print-template-multi.selected'),
            is_preview = $(this).hasClass('preview-only'),
            is_browse = $(this).hasClass('browse'),
            is_section = $(this).hasClass('section'),
            section_name = $(this).attr('data-section'),
            download = $(this).hasClass('download'),
            update_count_records = [];

        let print_payload = [];

        if (is_browse || is_section) {
            let $checked_records = $('.sub_chk:checked');

            if (is_section) {
                $checked_records = $(this).parents('.tbl-section.related').find('.sub_chk:checked');
            }
            $checked_records.each(function (index, $checked) {
                let record_id = $($checked).val(),
                    civis_opts = $($checked).attr('data-civis-options') ? $($checked).attr('data-civis-options') : "";

                if(civis_opts.length){
                    civis_opts = JSON.parse(civis_opts);
                }

                $templates.each(function (index, $template) {
                    let url = $($template).attr('href'),
                        send_to_printer = parseInt($($template).attr('data-send-to-printer'));
                    url = url.replace('{record_id}', record_id);

                    if (download) {
                        let segments = url.split("/");
                        segments[segments.length - 1] = "download";
                        url = segments.join("/");
                    }

                    if (window.tenant === 'pancetop' && is_section && section_name === 'tiskane_nalepke_c') {
                        update_count_records.push(record_id);
                    }

                    if(civis_opts.length){
                        $(civis_opts).each(function (index, opt) {
                            let pdfw = window.open(url + '?participant=' + opt, '_blank');
                            if (pdfw !== null) {
                                if (!download) {
                                    pdfw.focus();
                                }
                            } else {
                                bootbox.alert(translation.popup_blocked);
                            }
                        });
                    }else if (window.tenant === 'pancetop' && send_to_printer && !download) {
                        print_payload.push(url); // Add URL to the printer's payload
                    } else {
                        let pdfw = window.open(url, '_blank');
                        if (pdfw !== null) {
                            if (!download) {
                                pdfw.focus();
                            }
                        } else {
                            bootbox.alert(translation.popup_blocked);
                        }
                    }
                });
            });

            if (update_count_records.length) {
                updatePrintCounter(update_count_records);
            }
        } else {
            $templates.each(function (index, $template) {
                let url = $($template).attr('href'),
                    send_to_printer = parseInt($($template).attr('data-send-to-printer'));

                if (download) {
                    let segments = url.split("/");
                    segments[segments.length - 1] = "download";
                    url = segments.join("/");
                }

                if (window.tenant === 'pancetop' && send_to_printer && !download) {
                    print_payload.push(url); // Add URL to the printer's payload
                } else {
                    let pdfw = window.open(url, '_blank');
                    if (pdfw !== null) {
                        if (!download) {
                            pdfw.focus();
                            if (!is_preview && !download) {
                                pdfw.onload = function () {
                                    pdfw.print();
                                }
                            }
                        }
                    } else {
                        bootbox.alert(translation.popup_blocked);
                    }
                }
            });
        }

        // Call printDocuments only once after constructing the payload
        if (print_payload.length) {
            printDocuments(print_payload);
        }
    });

    $('.create-template').on('click', function (e) {
        e.preventDefault();
        let table_id = $(this).data('table-id'),
            type = $(this).data('type');

        bootbox.prompt("Enter Template name", function (result) {
            if (result) {
                if (result.length) {
                    $.ajax({
                        type: 'POST',
                        url: '/templates',
                        data: {
                            id: table_id,
                            type: type,
                            name: result
                        },
                        success: function (template_id) {
                            if (template_id) {
                                window.location = `/template/${template_id}/edit`;
                            }
                        }
                    })
                }
            }
        })
    });

    $('.import-html').click(function (e) {
        e.preventDefault();
        $('#file').click();
    });

    $('#file').on('change', function (e) {
        const file = $("#file")[0].files[0],
            template_id = $('#editor').data('template-id');
        if (file) {
            if (file.type === 'text/html') {
                bootbox.confirm("Are you sure want to replace existing template with your HTML?", function (result) {
                    if (result) {
                        let formData = new FormData();
                        formData.append('file', $("#file")[0].files[0]);
                        formData.append("template_id", template_id);

                        $.ajax({
                            type: 'POST',
                            url: '/template/import-html',
                            processData: false,
                            contentType: false,
                            data: formData,
                            success: function (res) {
                                if (res) {
                                    window.location.reload();
                                }
                            }
                        });
                    }
                })
            } else {
                alert('Invalid file type');
            }
        }
    });

    $('.duplicate-pdf').click(function (e) {
        e.preventDefault();
        let id = $(this).attr('data-template-id');
        bootbox.prompt(
            'Enter template name',
            function (result) {
                if (result) {
                    $.ajax({
                        type: 'POST',
                        url: '/templates/duplicate',
                        data: {
                            id,
                            name: result
                        },
                        success: function (res) {
                            if (res) {
                                window.open(`/template/${res}/edit`, '_blank');
                            }
                        }
                    })
                }
            });
    });

    $('.cancel-template').on('click', function (e) {
        let type = $(this).attr('data-type');
        window.location = `/templates/${type}`;
    });

    $('.save-template').on('click', function (e) {
        let type = $(this).attr('data-type'),
            content = type !== 'export' ? tinymce.get('editor').getContent() : '',
            template_header = type !== 'export' && type !== 'email' ? tinymce.get('editor-header').getContent() : '',
            template_footer = type !== 'export' && type !== 'email' ? tinymce.get('editor-footer').getContent() : '',
            $editor = type !== 'export' ? $('#editor') : '',
            pdfs = type !== 'export' ? $editor.attr('data-pdfs') : '',
            template_id = $(this).attr('data-template-id'),
            subject = type !== 'export' ? $('#template-subject').val() : '',
            file_name = type === 'pdf' ? $('#template-file-name').val() : '',
            $body = type !== 'export' ? tinymce.activeEditor.getBody() : '',
            footer = !!$($body).find('.footer').length,
            header = !!$($body).find('.header').length,
            templates = pdfs ? JSON.parse($('#editor').attr('data-pdfs')) : [],
            xml_exports = [];

        $('.xml-attachment').each(function (index, $xml_attachment) {
            let xml_export = {
                template_id: $($xml_attachment).attr('data-template-id'),
                filter_id: $($xml_attachment).attr('data-filter-id')
            };
            xml_exports.push(xml_export);
        });

        if (type === 'export') {
            let $fields = $('.export-field'),
                $sections = $('.export-section'),
                payload = {},
                sections = [],
                fields = [];

            $fields.each(function (index, $field) {
                let enabled = $($field).find('.visibility').is(':checked') ? 1 : 0;
                fields.push({
                    field: $($field).attr('data-id'),
                    enabled: enabled
                });
            });

            $sections.each(function (index, $section) {
                let enabled = $($section).find('.toggle-exp-sec').is(':checked') ? 1 : 0,
                    $fields = $($section).find('.section-export-field'),
                    section_fields = [];

                $fields.each(function (index, $field) {
                    let enabled = $($field).is(':checked') ? 1 : 0;

                    section_fields.push({
                        field: $($field).attr('data-id'),
                        enabled: enabled
                    });
                });

                sections.push({
                    section: $($section).attr('data-id'),
                    enabled: enabled,
                    fields: section_fields
                });
            });

            payload.fields = fields;
            payload.sections = sections;
            console.log(payload);
            content = JSON.stringify(payload);
        }

        $.ajax({
            type: 'PUT',
            url: '/templates',
            data: {
                id: template_id,
                template_content: content,
                template_header,
                template_footer,
                header: header,
                footer: footer,
                templates: templates,
                subject: subject,
                xml_exports: xml_exports,
                file_name: file_name
            },
            success: function (res) {
                if (res) {
                    toastr.success(translation.template_saved);
                }
            }
        });
    });

    $('.preview-template').on('click', function (e) {
        let template_id = $('#editor').data('template-id'),
            url = `/template/${template_id}/preview`,
            win = window.open(url, 'import-html');
        win.focus();
    });

    $('.delete-template').on('click', function (e) {
        let template_id = $(this).attr('data-template-id');

        bootbox.confirm({
            message: translation.delete_template_prompt,
            buttons: {
                confirm: {
                    label: translation.ok,
                    className: 'btn-primary'
                },
                cancel: {
                    label: translation.cancel,
                    className: 'btn-secondary'
                }
            },
            callback: function (result) {
                if (result) {
                    $.ajax({
                        type: 'DELETE',
                        url: '/templates',
                        data: {
                            id: template_id,
                        },
                        success: function (res) {
                            if (res) {
                                window.location = '/templates';
                            }
                        }
                    })
                }
            }
        });
    });

    $(document).on('change', '.toggle-exp-sec', function (e) {
        e.preventDefault();
        if ($(this).is(':checked')) {
            $(this).parents('.export-section').find('.collapse').addClass('show');
        } else {
            $(this).parents('.export-section').find('.collapse').removeClass('show');
        }
    });

    tinyMCE.baseURL = "/tinymce";

    $(document).on('focusin', function (e) {
        if ($(e.target).closest(".tox-dialog").length) {
            e.stopImmediatePropagation();
        }
    });

    tinymce.init({
        language: $('meta[name="language"]').attr('content'),
        fontsize_formats: "6pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 26pt 30pt 34pt",
        selector: '#email-footer',
        branding: false,
        menubar: 'edit insert view format table tools help',
        plugins: [
            "advlist autolink lists link image charmap print preview anchor numlist bullist",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste",
            "image imagetools"
        ],
        image_list: "/template/images/logos",
        paste_data_images: true,
        urlconverter_callback: function (url, node, on_save, name) {
            return url;
        },
        toolbar: `undo redo | styleselect | bold italic | link | alignleft aligncenter alignright | link image | numlist bullist | pastetext`,
        images_upload_url: '/template/images/upload',
        images_upload_handler: function (blobInfo, success, failure) {
            let xhr, formData;

            xhr = new XMLHttpRequest();
            xhr.withCredentials = false;
            xhr.open('POST', '/template/images/upload');

            xhr.onload = function () {
                let json;
                if (xhr.status != 200) {
                    failure('HTTP Error: ' + xhr.status);
                    return;
                }
                json = JSON.parse(xhr.responseText);
                if (!json || typeof json.location != 'string') {
                    failure('Invalid JSON: ' + xhr.responseText);
                    return;
                }
                success(json.location);
            };

            formData = new FormData();
            formData.append('file', blobInfo.blob(), blobInfo.filename());
            formData.append('_token', $(`meta[name="csrf-token"]`).attr('content'));
            xhr.send(formData);
        },
    });

    tinymce.init({
        language: $('meta[name="language"]').attr('content'),
        fontsize_formats: "6pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 26pt 30pt 34pt",
        selector: '#email-signature',
        branding: false,
        height: 400,
        menubar: 'edit insert view format table tools help',
        plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste",
            "image imagetools"
        ],
        image_list: "/template/images/logos",
        paste_data_images: true,
        urlconverter_callback: function (url, node, on_save, name) {
            return url;
        },
        images_upload_url: '/template/images/upload',
        images_upload_handler: function (blobInfo, success, failure) {
            let xhr, formData;

            xhr = new XMLHttpRequest();
            xhr.withCredentials = false;
            xhr.open('POST', '/template/images/upload');

            xhr.onload = function () {
                let json;
                if (xhr.status != 200) {
                    failure('HTTP Error: ' + xhr.status);
                    return;
                }
                json = JSON.parse(xhr.responseText);
                if (!json || typeof json.location != 'string') {
                    failure('Invalid JSON: ' + xhr.responseText);
                    return;
                }
                success(json.location);
            };

            formData = new FormData();
            formData.append('file', blobInfo.blob(), blobInfo.filename());
            formData.append('_token', $(`meta[name="csrf-token"]`).attr('content'));
            xhr.send(formData);
        },
    });

    let tinyMCE_HTML = {
            language: $('meta[name="language"]').attr('content'),
            fontsize_formats: "6pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 26pt 30pt 34pt",
            selector: '.create-edit-editor',
            branding: false,
            setup: function (editor) {
                editor.on('change', function (e) {
                    window.unsaved_changes = true;
                });
            },
            menubar: 'edit insert view format table tools help',
            content_style: "@font-face { font-family: 'Barlow SemiCondensed Light'; src: url('/fonts/BarlowSemiCondensed-Light.ttf') format('truetype'); } @font-face { font-family: 'Barlow SemiCondensed SemiBold'; src: url('/fonts/BarlowSemiCondensed-SemiBold.ttf') format('truetype'); }",
            font_formats: "Andale Mono=andale mono,times; Arial=Arial,helvetica,sans-serif; Arial Black=Arial Black; Book Antiqua=book antiqua,palatino; Calibri=Calibri; Calibri Bold=Calibri Bold; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Oswald=oswald; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats; BarlowSemiCondensed Light=Barlow SemiCondensed Light, sans-serif; BarlowSemiCondensed SemiBold=Barlow SemiCondensed SemiBold, sans-serif",
            plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste",
                "image imagetools"
            ],
            toolbar: `undo redo | styleselect | bold italic | link | alignleft aligncenter alignright | link image | numlist bullist | pastetext`,
            image_list: "/template/images/logos",
            paste_data_images: true,
            urlconverter_callback: function (url, node, on_save, name) {
                return url;
            },
            images_upload_url: '/template/images/upload',
            images_upload_handler: function (blobInfo, success, failure) {
                let xhr, formData;

                xhr = new XMLHttpRequest();
                xhr.withCredentials = false;
                xhr.open('POST', '/template/images/upload');

                xhr.onload = function () {
                    let json;
                    if (xhr.status != 200) {
                        failure('HTTP Error: ' + xhr.status);
                        return;
                    }
                    json = JSON.parse(xhr.responseText);
                    if (!json || typeof json.location != 'string') {
                        failure('Invalid JSON: ' + xhr.responseText);
                        return;
                    }
                    success(json.location);
                };

                formData = new FormData();
                formData.append('file', blobInfo.blob(), blobInfo.filename());
                formData.append('_token', $(`meta[name="csrf-token"]`).attr('content'));
                xhr.send(formData);
            },
        },
        tinyMCE_POPUP = tinyMCE_HTML;

    tinymce.init(tinyMCE_HTML);
    if ($('.create-edit-editor-popup').length) {
        tinyMCE_POPUP.selector = '.create-edit-editor-popup';
        tinyMCE_POPUP.height = '600px';
        tinymce.init(tinyMCE_POPUP);
    }

    if ($('#editor').length) {
        let type = $('#editor').attr('data-type'),
            tenant = $('#editor').attr('data-tenant'),
            table_id = $('#editor').attr('data-table-id'),
            toolbar_buttons = '';

        if (type === 'pdf') {
            toolbar_buttons = 'OnePageSection';
        } else if (type === 'email') {
            toolbar_buttons = 'attachPDFs | attachXML ';
        }

        let tinyOptions = {
            language: $('meta[name="language"]').attr('content'),
            fontsize_formats: "6pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 26pt 30pt 34pt",
            selector: '#editor',
            branding: false,
            height: 1100,
            menubar: 'edit insert view format table tools help',
            relative_urls: false,
            paste_data_images: true,
            urlconverter_callback: function (url, node, on_save, name) {
                return url;
            },
            plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste",
                "stickytoolbar image imagetools"
            ],
            content_style: "@font-face { font-family: 'Barlow SemiCondensed Light'; src: url('/fonts/BarlowSemiCondensed-Light.ttf') format('truetype'); } @font-face { font-family: 'Barlow SemiCondensed SemiBold'; src: url('/fonts/BarlowSemiCondensed-SemiBold.ttf') format('truetype'); }",
            font_formats: "Andale Mono=andale mono,times; Arial=Arial,helvetica,sans-serif; Arial Black=Arial Black; Book Antiqua=book antiqua,palatino; Calibri=Calibri; Calibri Bold=Calibri Bold; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Oswald=oswald; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats; BarlowSemiCondensed Light=Barlow SemiCondensed Light, sans-serif; BarlowSemiCondensed SemiBold=Barlow SemiCondensed SemiBold, sans-serif",
            images_upload_url: '/template/images/upload',
            images_upload_handler: function (blobInfo, success, failure) {
                let xhr, formData;

                xhr = new XMLHttpRequest();
                xhr.withCredentials = false;
                xhr.open('POST', '/template/images/upload');

                xhr.onload = function () {
                    let json;
                    if (xhr.status != 200) {
                        failure('HTTP Error: ' + xhr.status);
                        return;
                    }
                    json = JSON.parse(xhr.responseText);
                    if (!json || typeof json.location != 'string') {
                        failure('Invalid JSON: ' + xhr.responseText);
                        return;
                    }
                    success(json.location);
                };

                formData = new FormData();
                formData.append('file', blobInfo.blob(), blobInfo.filename());
                formData.append('_token', $(`meta[name="csrf-token"]`).attr('content'));
                xhr.send(formData);
            },
            file_picker_types: 'image',
            toolbar: `undo redo | styleselect | bold italic | link | alignleft aligncenter alignright | link image | numlist bullist | pastetext | placeholderButton | qrCodeButton | ${toolbar_buttons} | Settings `,
            image_list: "/template/images/logos?template_id=" + $('#editor').data('template-id'),
            setup: function (editor) {

                editor.ui.registry.addButton('attachPDFs', {
                    text: translation.attach_pdfs,
                    onAction: function () {
                        mceEditor = editor;
                        $('#template-pdf-modal').modal('show');
                    }
                });

                editor.ui.registry.addButton('attachXML', {
                    text: translation.attach_xml,
                    onAction: function () {
                        mceEditor = editor;
                        $('#template-exports-modal').modal('show');
                    }
                });

                editor.ui.registry.addButton('Settings', {
                    text: translation.settings,
                    onAction: function () {
                        mceEditor = editor;
                        $('#template-formatting').modal('show');
                        // if (window.tenant === 'pancetop') {
                        //     setupDefaultPrinters();
                        // }
                    }
                });

                editor.ui.registry.addButton('Subject', {
                    text: 'Subject',
                    onAction: function () {
                        bootbox.prompt({
                            title: "Enter Email Subject",
                            value: $('#editor').attr('data-subject'),
                            callback: function (result) {
                                if (result) {
                                    if (result.length) {
                                        $.ajax({
                                            type: 'POST',
                                            url: '/template/subject',
                                            data: {
                                                subject: result,
                                                id: $('#editor').attr('data-template-id')
                                            },
                                            success: function (template_id) {
                                                $('#editor').attr('data-subject', result);
                                            }
                                        })
                                    }
                                }
                            }
                        });
                    }
                });

                editor.ui.registry.addButton('placeholderButton', {
                    text: translation.add_placeholder,
                    onAction: function () {
                        mceEditor = editor;
                        $('#add-placeholder').attr('data-action', 'body');
                        selectTableFields();
                    }
                });

                editor.ui.registry.addButton('qrCodeButton', {
                    text: translation.qr_code,
                    onAction: function () {
                        mceEditor = editor;
                        $('#add-placeholder').attr('data-action', 'body');

                        // Get the currently selected HTML element
                        selectedElement = mceEditor.selection.getNode();

                        // Check if the selected element is an image with class "qr-image"
                        if (selectedElement.tagName === 'IMG' && selectedElement.classList.contains('qr-image')) {
                            let imgSrc = selectedElement.src;
                            // Pass the src URL as a parameter to the selectQrCodeFields function
                            selectQrCodeFields(imgSrc);
                        } else {
                            selectQrCodeFields();
                        }
                    }
                });

                editor.ui.registry.addToggleButton('OnePageSection', {
                    text: translation.display_on_single_page,
                    onAction: function () {
                        mceEditor = editor;

                        let node = $(tinymce.activeEditor.selection.getNode()).parents('table:first');

                        if ($(node).hasClass('single-page')) {
                            bootbox.alert("Highlighted section will be displayed on multiple pages.");
                        } else {
                            bootbox.alert("Highlighted section will be displayed on single page.");
                        }

                        $(node).toggleClass('single-page');
                    },
                });

                editor.ui.registry.addToggleButton('MarkAsHeader', {
                    text: 'Mark Header',
                    onAction: function (e) {
                        mceEditor = editor;

                        let node = $(tinymce.activeEditor.selection.getNode()).parents('table:first'),
                            $body = tinymce.activeEditor.getBody();

                        if ($(node).hasClass('footer')) {
                            bootbox.alert("Footer cannot be selected as a header.");
                        } else {
                            if ($(node).hasClass('header')) {
                                $(node).toggleClass('header');
                                bootbox.alert("Header removed");
                            } else {
                                if ($(node).hasClass('header')) {
                                    $(node).toggleClass('header');
                                    bootbox.alert("Header removed");
                                } else {
                                    if ($($body).find('.header').length) {
                                        bootbox.alert("Header already exists in template");
                                    } else {
                                        $(node).toggleClass('header');
                                        bootbox.alert("Highlighted section will be displayed on each page a header.");
                                    }
                                }
                            }
                        }
                    },
                });

                editor.ui.registry.addToggleButton('MarkAsFooter', {
                    text: 'Mark Footer',
                    onAction: function () {
                        mceEditor = editor;

                        let node = $(tinymce.activeEditor.selection.getNode()).parents('table:first'),
                            $body = tinymce.activeEditor.getBody();


                        if ($(node).hasClass('header')) {
                            bootbox.alert("Header cannot be selected as a footer.");
                        } else {
                            if ($(node).hasClass('footer')) {
                                $(node).toggleClass('footer');
                                bootbox.alert("Footer removed");
                            } else {
                                if ($($body).find('.footer').length) {
                                    bootbox.alert("Footer already exists in template");
                                } else {
                                    $(node).toggleClass('footer');
                                    bootbox.alert("Highlighted section will be displayed on each page a footer.");
                                }
                            }
                        }
                    },
                });
            }
        };
        if (tenant === 'master' && parseInt(table_id) === 62) {
            tinyOptions.urlconverter_callback = function (url, node, on_save, name) {
                return url;
            };
            tinyOptions.link_list = [
                {title: 'Verification URL', value: '@master{\'verification_url\'}'},
            ];
        }
        tinymce.init(tinyOptions);
        tinymce.init({
            language: $('meta[name="language"]').attr('content'),
            fontsize_formats: "6pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 26pt 30pt 34pt",
            selector: '#editor-header',
            branding: false,
            height: 300,
            menubar: 'edit insert view format table tools help',
            relative_urls: false,
            content_style: "@font-face { font-family: 'Barlow SemiCondensed Light'; src: url('/fonts/BarlowSemiCondensed-Light.ttf') format('truetype'); } @font-face { font-family: 'Barlow SemiCondensed SemiBold'; src: url('/fonts/BarlowSemiCondensed-SemiBold.ttf') format('truetype'); }",
            font_formats: "Andale Mono=andale mono,times; Arial=Arial,helvetica,sans-serif; Arial Black=Arial Black; Book Antiqua=book antiqua,palatino; Calibri=Calibri; Calibri Bold=Calibri Bold; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Oswald=oswald; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats; BarlowSemiCondensed Light=Barlow SemiCondensed Light, sans-serif; BarlowSemiCondensed SemiBold=Barlow SemiCondensed SemiBold, sans-serif",
            paste_data_images: true,
            urlconverter_callback: function (url, node, on_save, name) {
                return url;
            },
            plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste",
                "stickytoolbar image imagetools"
            ],
            images_upload_url: '/template/images/upload',
            images_upload_handler: function (blobInfo, success, failure) {
                let xhr, formData;

                xhr = new XMLHttpRequest();
                xhr.withCredentials = false;
                xhr.open('POST', '/template/images/upload');

                xhr.onload = function () {
                    let json;
                    if (xhr.status != 200) {
                        failure('HTTP Error: ' + xhr.status);
                        return;
                    }
                    json = JSON.parse(xhr.responseText);
                    if (!json || typeof json.location != 'string') {
                        failure('Invalid JSON: ' + xhr.responseText);
                        return;
                    }
                    success(json.location);
                };

                formData = new FormData();
                formData.append('file', blobInfo.blob(), blobInfo.filename());
                formData.append('_token', $(`meta[name="csrf-token"]`).attr('content'));
                xhr.send(formData);
            },
            file_picker_types: 'image',
            toolbar: `undo redo | styleselect | bold italic | link | alignleft aligncenter alignright | link image | numlist bullist | pastetext | placeholderButton | qrCodeButton | ${toolbar_buttons} | Settings `,
            image_list: "/template/images/logos?template_id=" + $('#editor').data('template-id'),
            setup: function (editor) {

            }
        });
        tinymce.init({
            language: $('meta[name="language"]').attr('content'),
            fontsize_formats: "6pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 26pt 30pt 34pt",
            selector: '#editor-footer',
            branding: false,
            height: 300,
            menubar: 'edit insert view format table tools help',
            relative_urls: false,
            content_style: "@font-face { font-family: 'Barlow SemiCondensed Light'; src: url('/fonts/BarlowSemiCondensed-Light.ttf') format('truetype'); } @font-face { font-family: 'Barlow SemiCondensed SemiBold'; src: url('/fonts/BarlowSemiCondensed-SemiBold.ttf') format('truetype'); }",
            font_formats: "Andale Mono=andale mono,times; Arial=Arial,helvetica,sans-serif; Arial Black=Arial Black; Book Antiqua=book antiqua,palatino; Calibri=Calibri; Calibri Bold=Calibri Bold; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Oswald=oswald; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats; BarlowSemiCondensed Light=Barlow SemiCondensed Light, sans-serif; BarlowSemiCondensed SemiBold=Barlow SemiCondensed SemiBold, sans-serif",
            paste_data_images: true,
            urlconverter_callback: function (url, node, on_save, name) {
                return url;
            },
            plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste",
                "stickytoolbar image imagetools"
            ],
            images_upload_url: '/template/images/upload',
            images_upload_handler: function (blobInfo, success, failure) {
                let xhr, formData;

                xhr = new XMLHttpRequest();
                xhr.withCredentials = false;
                xhr.open('POST', '/template/images/upload');

                xhr.onload = function () {
                    let json;
                    if (xhr.status != 200) {
                        failure('HTTP Error: ' + xhr.status);
                        return;
                    }
                    json = JSON.parse(xhr.responseText);
                    if (!json || typeof json.location != 'string') {
                        failure('Invalid JSON: ' + xhr.responseText);
                        return;
                    }
                    success(json.location);
                };

                formData = new FormData();
                formData.append('file', blobInfo.blob(), blobInfo.filename());
                formData.append('_token', $(`meta[name="csrf-token"]`).attr('content'));
                xhr.send(formData);
            },
            file_picker_types: 'image',
            toolbar: `undo redo | styleselect | bold italic | link | alignleft aligncenter alignright | link image | numlist bullist | pastetext | placeholderButton | qrCodeButton | ${toolbar_buttons} | Settings `,
            image_list: "/template/images/logos?template_id=" + $('#editor').data('template-id'),
            setup: function (editor) {

            }
        });
    }

    $('body').on('changed.bs.select', '#section-picker', function (e, clickedIndex, isSelected, previousValue) {
        let $selected_field_type = $('#relation-field').find('option:selected'),
            name = $selected_field_type.val(),
            user_fields = ['assigned_to', 'created_by', 'updated_by', 'multi_assigned_to'],
            table_id = $('#editor').data('table-id');

        if(!isSelected && !previousValue){
            $('#col-preview').html('');
        }

        if ($selected_field_type.data('field-type') !== 'relationship' &&
            $selected_field_type.data('field-type') !== 'record' &&
            !user_fields.includes(name)
        ) {
            let fullRender = previousValue && previousValue.length ? 'No' : 'Yes',
                values = $(this).val(),
                column = previousValue ? values.filter(x => !previousValue.includes(x)).concat(previousValue.filter(x => !values.includes(x)))[0] : [];

            if($('#aggregateBy').is(':checked') && $('#count').is(':checked')){
                fullRender = 'Yes';
            }

            if (isSelected) {
                $.ajax({
                    type: 'GET',
                    url: '/table/section/columns/preview',
                    data: {
                        column: column,
                        fullRender: fullRender,
                        index: clickedIndex,
                        table_id,
                        section_name: name
                    },
                    success: function (res) {
                        if (fullRender === 'Yes') {
                            $('#col-preview').html(res);
                            $("#sort-preview").sortable({cursor: 'grab'});
                        } else {
                            $('#sort-preview').append(res);
                        }
                    }
                });
            } else {
                $('.section-col[data-column="' + clickedIndex + '"]').remove();
            }
        }
    });

    // function setupDefaultPrinters() {
    //     var $printersContainer = $('#default-printer'),
    //         selected_printer = $printersContainer.attr('data-user-printer'); // Get pre-selected printer
    //
    //     $printersContainer.empty(); // Clear previous content
    //     $printersContainer.append(`<option value="">Select printer</option>`);
    //
    //     // Start JSPrintManager WebSocket only if it hasn't been started
    //     if (!JSPM.JSPrintManager.websocket_status ||
    //         JSPM.JSPrintManager.websocket_status != JSPM.WSStatus.Open) {
    //         JSPM.JSPrintManager.start();
    //     }
    //
    //     // Function to populate printers and set selected printer
    //     function populatePrinters() {
    //         console.log("JSPrintManager is ready!");
    //
    //         // Get available printers
    //         JSPM.JSPrintManager.getPrinters().then(function (printers) {
    //             console.log("Available Printers:", printers);
    //
    //             $.each(printers, function (index, printer) {
    //                 $printersContainer.append(`<option value="${printer}">${printer}</option>`);
    //             });
    //
    //             // Set the selected printer if available
    //             if (selected_printer) {
    //                 $printersContainer.val(selected_printer);
    //             }
    //         });
    //     }
    //
    //     // Check WebSocket status
    //     if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
    //         populatePrinters();
    //     } else {
    //         JSPM.JSPrintManager.WS.onStatusChanged = function () {
    //             if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
    //                 populatePrinters();
    //             } else {
    //                 console.log("JSPrintManager WebSocket is not open.");
    //             }
    //         };
    //     }
    // }

    $('#send-to-printer').on('change', function (e) {
        let printer = $(this).val();
        $(this).attr('data-user-printer', printer);
    });

    $('.add-subject-placeholder').on('click', function (e) {
        e.preventDefault();
        $('#add-placeholder').attr('data-action', 'subject');
        selectTableFields();
    });

    $('.add-file-name-placeholder').on('click', function (e) {
        e.preventDefault();
        $('#add-placeholder').attr('data-action', 'file_name');
        selectTableFields();
    });

    $('#save-formatting').on('click', function (e) {
        let counter_separator = $('#counter-separator').val(),
            counter_position = $('#counter-position').val(),
            counter_alignment = $('#counter-alignment').val(),
            counter_font_size = $('#counter-font-size').val(),
            counter_font = $('#counter-font').val(),
            hide_counter = $('#hide-counter').is(':checked') ? 1 : 0,
            template_name = $('#template-name').val(),
            template_description = $('#template-description').val(),
            template_visibility = $('.template-visibility:checked').val(),
            template_users = $('#template-users').val(),
            template_groups = $('#template-groups').val(),
            header_height = $('#header-height').val(),
            footer_height = $('#footer-height').val(),
            page_setup = $('#page-setup').is(':checked') ? 1 : 0,
            page_height = $('#page-height').val(),
            page_width = $('#page-width').val(),
            margin_top = $('#margin-top').val(),
            margin_bottom = $('#margin-bottom').val(),
            margin_left = $('#margin-left').val(),
            margin_right = $('#margin-right').val(),
            orientation = $('input[name="orientation"]:checked').val(),
            show_borders = $('#show_borders').is(':checked') ? 1 : 0,
            hide_without_records = $('#hide_without_records').is(':checked') ? 1 : 0,
            no_decimals = $('#no_decimals').is(':checked') ? 1 : 0,
            table_header_color = $('#table-header-color').val(),
            table_header_text_color = $('#table-header-text-color').val(),
            send_to_printer = '',
            row_space = $('#table-row-space').val(),
            id = $(this).attr('data-id'),
            type = $(this).attr('data-type');

        if (window.tenant === 'pancetop') {
            send_to_printer = $('#send-to-printer').val();
        }

        if (type === 'pdf') {
            if (!/^\d+$/.test(counter_font_size)) {
                alert('Please enter a numeric value for font size');
                return;
            }

            if (counter_font_size < 8 || counter_font_size > 20) {
                alert('Font size must be greater than 8px and less than 20px');
                return;
            }
        }

        $.ajax({
            type: 'POST',
            url: '/template/formatting',
            data: {
                id: id,
                counter_separator,
                counter_position,
                counter_alignment,
                counter_font_size,
                counter_font,
                hide_counter,
                header_height,
                footer_height,

                template_name,
                template_description,
                template_visibility,
                template_users,
                template_groups,

                page_setup,
                page_height,
                page_width,
                margin_top,
                margin_left,
                margin_right,
                margin_bottom,
                orientation,
                show_borders,
                hide_without_records,
                no_decimals,

                table_header_color,
                table_header_text_color,
                row_space,
                send_to_printer
            },
            success: function (res) {
                if (res) {
                    toastr.success('Formatting settings saved');
                    $('#template-formatting').modal('hide');
                }
            }
        })
    });

    function selectTableFields() {
        let table_id = $('#editor').data('table-id'),
            $modal = $('#placeholder-modal'),
            $modalBody = $('#placeholder-body');

        $.ajax({
            type: 'GET',
            url: '/table/relations',
            data: {
                id: table_id,
            },
            success: function (res) {
                $modalBody.html(res);
                $('.picker').selectpicker({
                    container: 'body',
                    noneSelectedText: translation.nothing_selected
                });
            }
        });

        $modal.modal('show');
    }

    function selectQrCodeFields(qr_url = '') {
        let table_id = $('#editor').data('table-id'),
            $modal = $('#qrcode-modal'),
            $modalBody = $('#qrcode-body');

        $('.add-qr-text, .save-qr-text').addClass('d-none');

        $.ajax({
            type: 'GET',
            url: '/table/relations',
            data: {
                id: table_id,
                isQrCode: 1,
                qr_url
            },
            success: function (res) {
                $modalBody.html(res);
                $('.picker').selectpicker({
                    container: 'body',
                    noneSelectedText: translation.nothing_selected
                });
                if (qr_url.length) {
                    $("#qr-preview").sortable({cursor: 'grab'});
                    $('.add-qr-text').removeClass('d-none');
                } else {
                    $('.save-qr-text').removeClass('d-none');
                }
            }
        });

        $modal.modal('show');
    }

    $(document).on('change', 'input[name="section-type"]', function() {
        if ($('#detailedRows').is(':checked')) {
            $('.section-sub-group').addClass('d-none');
            $('.select-aggregate').addClass('d-none');
            $('#section-picker')
                .data('maxOptions', false)
                .selectpicker('refresh');
        } else {
            $('.section-sub-group').removeClass('d-none');
            $('.select-aggregate').removeClass('d-none');
        }
        $('input[name="section-sub-type"]').trigger('change');
        $('#section-picker').val([]).trigger('change');
        getColumns(['aggregate', 'columns']);
    });

    $(document).on('change', 'input[name="section-sub-type"]', function () {
        if (($('#count').is(':checked') && $('#aggregateBy').is(':checked'))) {
            $('#section-picker')
                .data('maxOptions', 1)
                .selectpicker('refresh');
            $('.select-aggregate').addClass('d-none');
        } else if (($('#summarize').is(':checked') || $('#aggregateBy').is(':checked')) && !$('#detailedRows').is(':checked')) {
            $('#section-picker')
                .data('maxOptions', false)
                .selectpicker('refresh');
            $('.select-aggregate').removeClass('d-none');
        }
        $('#section-picker').val([]).trigger('change');
        getColumns(['columns']);
    });

    function getColumns(dropdowns){
        let value = $('#relation-field').val(),
            table_id = $('#editor').data('table-id'),
            $picker = $('#section-picker'),
            $aggregate_by = $('#aggregate-by'),
            number_row = $('#aggregateBy').is(':checked') ? 0 : 1,
            sub_type = $('#summarize').is(':checked') && !$('#detailedRows').is(':checked') ? 'summarize' : 'count';

        $.ajax({
            type: 'GET',
            url: '/table/section/columns',
            data: {
                section: value,
                table_id: table_id,
                number_row: number_row,
                sub_type
            },
            success: function (res) {
                if(dropdowns.includes('columns')){
                    $picker.selectpicker('destroy');
                    $picker.empty().append(res.columns);
                    $picker.attr('multiple', true);
                    $picker.selectpicker({
                        container: 'body',
                        noneSelectedText: translation.nothing_selected
                    });
                }

                if(dropdowns.includes('aggregate')){
                    $aggregate_by.selectpicker('destroy');
                    $aggregate_by.empty().append(res.columns);
                    $aggregate_by.selectpicker({
                        container: 'body',
                        noneSelectedText: translation.nothing_selected
                    });
                }
            }
        })
    }

    $(document).on('change', '#relation-field', function (e) {
        let value = $(this).val(),
            table_id = $('#editor').data('table-id'),
            $picker = $('.picker'),
            $filters = $('#table-filter'),
            type = $(this).find(':selected').data('field-type'),
            $show_header = $('.show-header'),
            $related_columns = $('#relation-columns'),
            $select_filters = $('.select-filters'),
            $company_columns = $('#company-columns'),
            $table_header = $('.show-header'),
            $record_options = $('.record-holder-options'),
            $group_by = $('#record-group-by'),
            $aggregate_options = $('.aggregate-options'),
            $aggregate_by = $('#aggregate-by'),
            $select_aggregate = $('.select-aggregate');

        $related_columns.addClass('d-none');
        $company_columns.addClass('d-none');
        $record_options.addClass('d-none');
        $select_filters.addClass('d-none');
        $aggregate_options.addClass('d-none');
        $select_aggregate.addClass('d-none');

        if (value.length) {
            if (type === 'relationship') {
                $.ajax({
                    type: 'GET',
                    url: '/table/relation/columns',
                    data: {
                        field: value,
                        table_id: table_id,
                    },
                    success: function (res) {
                        $picker.selectpicker('destroy');
                        $picker.append(res);
                        $picker.attr('multiple', false);
                        $picker.selectpicker({
                            container: 'body',
                            noneSelectedText: translation.nothing_selected
                        });

                        $related_columns.removeClass('d-none');
                        $table_header.removeClass('d-none');
                        $show_header.addClass('d-none');
                    }
                })
            } else if (type === 'section') {
                $.ajax({
                    type: 'GET',
                    url: '/table/section/columns',
                    data: {
                        section: value,
                        table_id: table_id,
                        number_row: 1
                    },
                    success: function (res) {
                        $picker.selectpicker('destroy');
                        $picker.empty().append(res.columns);
                        $filters.empty().append(res.filters);
                        $picker.attr('multiple', true);
                        $picker.selectpicker({
                            container: 'body',
                            noneSelectedText: translation.nothing_selected
                        });

                        $aggregate_by.selectpicker('destroy');
                        $aggregate_by.empty().append(res.columns);
                        $aggregate_by.selectpicker({
                            container: 'body',
                            noneSelectedText: translation.nothing_selected
                        });

                        $related_columns.removeClass('d-none');
                        $select_filters.removeClass('d-none');
                        $table_header.removeClass('d-none');
                        $show_header.removeClass('d-none');
                        $aggregate_options.removeClass('d-none');
                    }
                });
            } else if (type === 'record') {
                $record_options.removeClass('d-none');
                $.ajax({
                    type: 'GET',
                    url: '/tablebuilder/table/fields/dropdown',
                    data: {
                        id: table_id,
                    },
                    success: function (res) {
                        $picker.selectpicker('destroy');
                        $picker.empty().append(res);
                        $group_by.empty().append(res);
                        $picker.append('<option value="@record_url">Record URL</option>');
                        $picker.attr('multiple', true);
                        $picker.selectpicker({
                            container: 'body',
                            noneSelectedText: translation.nothing_selected
                        });
                        $related_columns.removeClass('d-none');
                    }
                })
            } else if (type === 'record_url') {
                $picker.find('option').remove();
                $picker.selectpicker('destroy');
                $picker.selectpicker({
                    container: 'body',
                    noneSelectedText: translation.nothing_selected
                });
                $related_columns.addClass('d-none');
                $table_header.addClass('d-none');
            } else if (type === 'company_info') {
                $company_columns.removeClass('d-none');
            } else if (
                value === 'assigned_to' ||
                value === 'multi_assigned_to' ||
                value === 'created_by' ||
                value === 'updated_by') {
                $.ajax({
                    type: 'GET',
                    url: '/users/columns',
                    success: function (res) {
                        $picker.selectpicker('destroy');
                        $picker.append(res);
                        $picker.attr('multiple', false);
                        $picker.selectpicker({
                            container: 'body',
                            noneSelectedText: translation.nothing_selected
                        });

                        $related_columns.removeClass('d-none');
                        $table_header.removeClass('d-none');
                        $show_header.addClass('d-none');
                    }
                })
            } else {
                $picker.find('option').remove();
                $picker.selectpicker('destroy');
                $picker.selectpicker({
                    container: 'body',
                    noneSelectedText: translation.nothing_selected
                });
                $related_columns.addClass('d-none');
                $table_header.addClass('d-none');
            }
        } else {
            $picker.find('option').remove();
            $picker.selectpicker('destroy');
            $picker.selectpicker({
                container: 'body',
                noneSelectedText: translation.nothing_selected
            });
            $related_columns.addClass('d-none');
            $table_header.addClass('d-none');
        }
    });

    $(document).on('click', '#add-placeholder', function (e) {
        let $columns = $(".picker option:selected"),
            $relation_field = $('#relation-field'),
            filter = $('#table-filter').val(),
            relation_field = $relation_field.val(),
            type = $relation_field.find(':selected').data('field-type'),
            placeholder = '',
            fields = [],
            $show_header = $('#show-header'),
            show_header = $show_header.is(':checked'),
            $modal = $('#placeholder-modal'),
            $modalBody = $('#placeholder-body'),
            $error = $('.error'),
            action = $(this).attr('data-action'),
            company_field = $('#company-fields').val(),
            record_group_by = $('#record-group-by').val(),
            show_field_names = $('#show-field-names').is(':checked'),
            show_next_line = $('#show-next-line').is(':checked')

        $('.picker').selectpicker('destroy');

        $error.text('');
        if (relation_field.length) {
            if (type === 'relationship') {
                if ($columns.length) {
                    $($columns).each(function (i, $column) {
                        fields.push($($column).val());
                    });
                    placeholder = `@relation{["${relation_field}",${JSON.stringify(fields)}]}`;
                    if (action === 'subject') {
                        setTemplateSubjectPlaceholder(placeholder);
                    } else if (action === 'file_name') {
                        setTemplateFileNamePlaceholder(placeholder);
                    } else {
                        mceEditor.insertContent(placeholder);
                    }
                    $modalBody.empty();
                    $modal.modal('hide');
                } else {
                    $error.text('Please select columns');
                }
            } else if (
                relation_field === 'assigned_to' ||
                relation_field === 'multi_assigned_to' ||
                relation_field === 'created_by' ||
                relation_field === 'updated_by') {
                let user_column = $(".picker option:selected").val();
                if (user_column.length) {
                    placeholder = `@user{["${relation_field}","${user_column}"]}`;
                    if (action === 'subject') {
                        setTemplateSubjectPlaceholder(placeholder);
                    } else if (action === 'file_name') {
                        setTemplateFileNamePlaceholder(placeholder);
                    } else {
                        mceEditor.insertContent(placeholder);
                    }
                    $modalBody.empty();
                    $modal.modal('hide');
                } else {
                    $error.text('Please select column');
                }
            } else if (type === 'record') {
                if ($columns.length) {
                    $($columns).each(function (i, $column) {
                        if ($($column).val() === '@record_url') {
                            fields.push('@record_url');
                        } else {
                            fields.push($($column).attr('data-name'));
                        }
                    });
                    let options = {
                        record_group_by,
                        show_field_names,
                        show_next_line
                    };
                    placeholder = `@record([[${JSON.stringify(options)}],[${JSON.stringify(fields)}]])`;
                    if (action === 'subject') {
                        setTemplateSubjectPlaceholder(placeholder);
                    } else if (action === 'file_name') {
                        setTemplateFileNamePlaceholder(placeholder);
                    } else {
                        mceEditor.insertContent(placeholder);
                    }
                    $modalBody.empty();
                    $modal.modal('hide');
                } else {
                    $error.text('Please select columns');
                }
            } else if (type === 'section') {
                let type = $('#aggregateBy').is(':checked') ? 'aggregate' : 'detailed',
                    sub_type = '';

                if($('#aggregateBy').is(':checked') && $('#count').is(':checked')){
                    sub_type = 'count';
                }

                if($('#aggregateBy').is(':checked') && $('#summarize').is(':checked')){
                    sub_type = 'summarize';
                }

                if ($columns.length) {
                    let $cols = $('.section-col'),
                        payload = {};

                    $($cols).each(function (i, $column) {
                        let value = $($column).attr('data-column-name'),
                            type = $($column).attr('data-field-type'),
                            col_rename = $($column).find('.col-rename').val(),
                            $merge = $($column).find('.merge'),
                            width = $($column).find('.percentage').val(),
                            align = $($column).find('.alignment').val();

                        if (type === 'relationship') {
                            let primary_col = $($column).find('.relation-primary-column').val();
                            if (primary_col.length) {
                                value = [value, primary_col];
                            }
                        }

                        let data = [value, col_rename, width, align];

                        if ($merge.is(':checked')) {
                            data.push('merge');
                        }
                        fields.push(data);
                    });

                    // if (filter.length) {
                    //     relation_field = `${relation_field},${filter}`;
                    // }

                    payload.name = relation_field;
                    payload.type = type;
                    payload.sub_type = sub_type;
                    payload.filter = filter;
                    payload.header = show_header;

                    if(type === 'aggregate' && sub_type === 'summarize'){
                        payload.aggregate_by = $('#aggregate-by').val();
                    }

                    payload.fields = fields;


                    placeholder = `@section("${JSON.stringify(payload)}")`;
                    if (action === 'subject') {
                        setTemplateSubjectPlaceholder(placeholder);
                    } else if (action === 'file_name') {
                        setTemplateFileNamePlaceholder(placeholder);
                    } else {
                        mceEditor.insertContent(placeholder);
                    }
                    $modalBody.empty();
                    $modal.modal('hide');
                } else {
                    $error.text('Please select columns');
                }
            } else if (type === 'company_info') {
                placeholder = `@company{${company_field}}`;
                if (action === 'subject') {
                    setTemplateSubjectPlaceholder(placeholder);
                } else if (action === 'file_name') {
                    setTemplateFileNamePlaceholder(placeholder);
                } else {
                    mceEditor.insertContent(placeholder);
                }
                $modalBody.empty();
                $modal.modal('hide');
            } else if (type === 'record_url') {
                placeholder = `@record_url`;
                if (action === 'subject') {
                    setTemplateSubjectPlaceholder(placeholder);
                } else if (action === 'file_name') {
                    setTemplateFileNamePlaceholder(placeholder);
                } else {
                    mceEditor.insertContent(placeholder);
                }
                $modalBody.empty();
                $modal.modal('hide');
            } else {
                placeholder = `\${${relation_field}}`;
                if (action === 'subject') {
                    setTemplateSubjectPlaceholder(placeholder);
                } else if (action === 'file_name') {
                    setTemplateFileNamePlaceholder(placeholder);
                } else {
                    mceEditor.insertContent(placeholder);
                }
                $modalBody.empty();
                $modal.modal('hide');
            }
        } else {
            $error.text('Please select field');
        }
    });

    $(document).on('click', '#insert-qrcode-field', function (e) {
        let $columns = $(".picker option:selected"),
            $relation_field = $('#relation-field'),
            relation_field = $relation_field.val(),
            type = $relation_field.find(':selected').data('field-type'),
            placeholder = '',
            fields = [],
            $error = $('.error'),
            action = $(this).attr('data-action'),
            // $qr_code_input = $('#qr-code-text'),
            // placeholder_value = $qr_code_input.val().trim(),
            template_id = $('.save-template').attr('data-template-id');

        let filter = $('#table-filter').val(),
            $show_header = $('#show-header'),
            show_header = $show_header.is(':checked'),
            $modal = $('#placeholder-modal'),
            $modalBody = $('#placeholder-body'),
            company_field = $('#company-fields').val(),
            record_group_by = $('#record-group-by').val(),
            show_field_names = $('#show-field-names').is(':checked'),
            show_next_line = $('#show-next-line').is(':checked')

        $('.picker').selectpicker('destroy');

        $error.text('');
        if (relation_field.length) {
            if (type === 'relationship') {
                if ($columns.length) {
                    $($columns).each(function (i, $column) {
                        fields.push($($column).val());
                    });
                    placeholder = `@relation{["${relation_field}",${JSON.stringify(fields)}]}`;
                    // placeholder = placeholder_value + ' ' + placeholder;
                    // $qr_code_input.val(placeholder);
                } else {
                    $error.text('Please select columns');
                }
            } else if (
                relation_field === 'assigned_to' ||
                relation_field === 'multi_assigned_to' ||
                relation_field === 'created_by' ||
                relation_field === 'updated_by') {
                let user_column = $(".picker option:selected").val();
                if (user_column.length) {
                    placeholder = `@user{["${relation_field}","${user_column}"]}`;
                    // placeholder = placeholder_value + ' ' + placeholder;
                    // $qr_code_input.val(placeholder);
                } else {
                    $error.text('Please select column');
                }
            } else if (type === 'record') {
                if ($columns.length) {
                    $($columns).each(function (i, $column) {
                        if ($($column).val() === '@record_url') {
                            fields.push('@record_url');
                        } else {
                            fields.push($($column).attr('data-name'));
                        }
                    });
                    let options = {
                        record_group_by,
                        show_field_names,
                        show_next_line
                    };
                    placeholder = `@record([[${JSON.stringify(options)}],[${JSON.stringify(fields)}]])`;
                    // placeholder = placeholder_value + ' ' + placeholder;
                    // $qr_code_input.val(placeholder);
                } else {
                    $error.text('Please select columns');
                }
            } else if (type === 'company_info') {
                placeholder = `@company{${company_field}}`;
                // placeholder = placeholder_value + ' ' + placeholder;
                // $qr_code_input.val(placeholder);
            } else if (type === 'record_url') {
                placeholder = `@record_url`;
                // placeholder = placeholder_value + ' ' + placeholder;
                // $qr_code_input.val(placeholder);
            } else if (type === 'upn') {
                placeholder = `@upn_checksum`;
                // placeholder = placeholder_value + ' ' + placeholder;
                // $qr_code_input.val(placeholder);
            } else if (type === 'custom') {
                placeholder = ``;
                // placeholder = placeholder_value + ' ' + placeholder;
                // $qr_code_input.val(placeholder);
            } else {
                placeholder = `\${${relation_field}}`;
                // placeholder = placeholder_value + ' ' + placeholder;
                // $qr_code_input.val(placeholder);
            }

            AddQRPreviewRow(template_id, relation_field, placeholder);
        } else {
            $error.text('Please select field');
        }
    });

    function AddQRPreviewRow(template_id, relation_field, placeholder) {
        let $qr_row_container = $('.qr-rows-container'),
            $rows = $qr_row_container.find('.qr-rows-header'),
            fullRender = $rows.length ? 'no' : 'yes';

        $.ajax({
            type: 'GET',
            url: '/templates/qr-code/preview',
            data: {
                template_id,
                relation_field,
                placeholder,
                fullRender
            },
            success: function (res) {
                if (res) {
                    if (fullRender === 'yes') {
                        $qr_row_container.append(res);
                        $("#qr-preview").sortable({cursor: 'grab'});
                    } else {
                        $('#qr-preview').append(res);
                    }
                }
            }
        })
    }

    $(document).on('click', '.remove-qr-row', function (e) {
        $(this).parents('.qr-row').remove();
    });

    $(document).on('keyup', '.max-character', function (e) {
        var minValue = parseInt($(this).attr('min'));
        var currentValue = parseInt($(this).val());

        if (currentValue < minValue) {
            $(this).val(minValue);
        }
    });

    $(document).on('click', '#add-qrcode', function (e) {
        let $modal = $('#qrcode-modal'),
            $modalBody = $('#qrcode-body');

        let $qr_rows = $('.qr-row'),
            payload = [];

        $.each($qr_rows, function (index, $qr_row) {
            $qr_row = $($qr_row);
            let placeholder = $qr_row.find('.qr-placeholder').val(),
                max_character = $qr_row.find('.max-character').val(),
                separator = $qr_row.find('.separator').val(),
                newline = $qr_row.find('.newline').is(':checked') ? 1 : 0,
                $add_zero = $qr_row.find('.leading-zeros'),
                add_zero = 0,
                is_custom = $qr_row.attr('data-is-custom'),
                field = $qr_row.attr('data-field-id');

            if ($add_zero.length && $add_zero.is(':checked')) {
                add_zero = 1;
            }

            payload.push({
                placeholder,
                max_character,
                separator,
                newline,
                is_custom,
                field,
                add_zero
            });
        });

        payload = JSON.stringify(payload);
        let encodedValue = encodeURIComponent(payload);

        if (selectedElement && selectedElement.tagName === 'IMG' && selectedElement.classList.contains('qr-image')) {
            mceEditor.dom.setAttrib(selectedElement, 'src', `https://${tenant}.freelifecrm.com/images/fields/qrcode.png?qr_string=${encodedValue}`);
        } else {
            // Insert a new QR image
            mceEditor.insertContent(
                `<img class="qr-image" src="https://${tenant}.freelifecrm.com/images/fields/qrcode.png?qr_string=${encodedValue}" alt="QR Code"/>`
            );
        }

        $modalBody.empty();
        $modal.modal('hide');
    });

    function setTemplateSubjectPlaceholder(placeholder) {
        let value = $('#template-subject').val().trim();

        if (value.length) {
            value = `${value} ${placeholder}`;
        } else {
            value = placeholder;
        }
        $('#template-subject').val(value);
    }

    function setTemplateFileNamePlaceholder(placeholder) {
        let value = $('#template-file-name').val().trim();

        if (value.length) {
            value = `${value} ${placeholder}`;
        } else {
            value = placeholder;
        }
        $('#template-file-name').val(value);
    }

    $('#placeholder-modal').on('hidden.bs.modal', function () {
        $('#placeholder-body').empty();
    });

    $('#qrcode-modal').on('hidden.bs.modal', function () {
        $('#qrcode-body').empty();
    });

    $('.html-to-pdf').on('click', function (e) {
        let template_id = $(this).data('template-id'),
            record_id = $(this).data('record-id'),
            action = $(this).data('action'),
            type = $(this).data('multiple') ? 'records' : 'record',
            url = `/template/${template_id}/${type}/${record_id}/${action}`,
            win = window.open(url, 'import-html');
        win.focus();
    });

    $('.init-send-email, .send-email').on('click', function (e) {
        e.preventDefault();

        $('#mail-modal').modal('toggle');
    });


    $('#cancel-email').on('click', function (e) {
        e.preventDefault();
        $('#mail-modal').modal('toggle');
    });

    $('#send-mail').on('click', function (e) {
        e.preventDefault();
        $('#submit-email-modal').trigger('click');
    });

    $(".template-visibility").on('change', function (e) {
        if ($(this).val() === '1') {
            $('.template-user-groups').removeClass('d-none');
        } else {
            $('.template-user-groups').addClass('d-none');
        }
    });

    $('.select-pdfs').on('change', function (e) {
        e.preventDefault();
        let templates = $(this).val();

        $('#editor').attr('data-pdfs', JSON.stringify(templates));
    });

    $('#add-template-export').on('click', function (e) {
        let filter = $('#template-export-filter').val(),
            template = $('#template-export-template').val();

        if (!filter.length) {
            toastr.error('Please select filter');
            return;
        }

        if (!template.length) {
            toastr.error('Please select template');
            return;
        }

        let filter_name = $('#template-export-filter option:selected').text().trim(),
            template_name = $('#template-export-template option:selected').text().trim();

        let $xml_attachments = `<div class="xml-attachment" data-template-id="${template}" data-filter-id="${filter}">
                                    ${template_name} (${filter_name}) <i class="fa fa-times ml-2 rm-xml-attachment" style="cursor: pointer"></i>
                                </div>`;
        $('.xml-attachments').append($xml_attachments).removeClass('d-none');
        $('#template-exports-modal').modal('hide');
    });

    $(document).on('click', '.rm-xml-attachment', function (e) {
        $(this).parents('.xml-attachment').remove();

        if (!$('.xml-attachment').length) {
            $('.xml-attachments').addClass('d-none');
        }
    });

    $(document).on('change', '#page-setup', function (e) {
        if ($(this).is(':checked')) {
            $('.page-setup-options').removeClass('d-none');
        } else {
            $('.page-setup-options').addClass('d-none');
        }
    });

    $(".column-list, .section-list").sortable({
        items: "li",
        cursor: 'grab',
        opacity: 0.6,
        connectToSortable: '.li',
        forcePlaceholderSize: true,
    });

    $('.browse-export').on('click', function (e) {
        e.preventDefault();
        let table_id = $(this).attr('data-table-id'),
            type = $(this).attr('data-type'),
            query = window.location.search;

        $.ajax({
            type: "GET",
            url: '/export-browse/' + table_id + query,
            data: {
                table_id,
                type,
                export: true
            },
            success: function (res) {
                if (res) {
                    let xls = window.open(res, '_blank');
                    xls.focus();
                }
            }
        })
    });

    $('.xls-export').on('click', function (e) {
        e.preventDefault();
        let template_id = $(this).attr('data-template-id'),
            record_id = $(this).attr('data-record-id');

        console.log(template_id, record_id);

        $.ajax({
            type: "GET",
            url: '/export/xls',
            data: {
                template_id,
                record_id
            },
            success: function (res) {
                if (res) {
                    let xls = window.open(res, '_blank');
                    xls.focus();
                }
            }
        })
    });

    $('.toggle-template').on('change', function (e) {
        let id = $(this).attr('data-id'),
            enabled = $(this).is(':checked') ? 1 : 0;

        $.ajax({
            type: 'POST',
            url: '/templates/toggle',
            data: {
                id,
                enabled: enabled
            },
            success: function (res) {
            }
        });
    });

    $('.template-table').each(function () {
        var tallestHeight = 0,
            headerHeight = 0;

        $(this).find('thead th').each(function () {
            var thHeight = $(this).outerHeight() - 5;
            headerHeight = $(this).parents('tr').outerHeight();
            if (thHeight > tallestHeight) {
                tallestHeight = thHeight;
            }
        });

        // Set the height of all th elements to the tallest height
        if (tallestHeight < headerHeight) {
            tallestHeight = headerHeight;
        }
        $(this).find('thead th').css('height', tallestHeight);
    });
});